import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ILoginState } from './login';

const exampleStateSelector =
  createFeatureSelector<ILoginState>('login');

export const selectToken = createSelector(
  exampleStateSelector,
  (state: ILoginState) => state.authToken
);

export const selectEsito = createSelector(
  exampleStateSelector,
  (state: ILoginState) => state.esito || ''
);

export const selectServizi = createSelector(
  exampleStateSelector,
  (state: ILoginState) => state.servizi || []
);
